module.exports = __webpack_public_path__ + "img/app.d3f2b3a2.jpg";